export default __webpack_public_path__ + "videoId_privacy_policy.pdf";